export default __webpack_public_path__ + "static/media/box-icon.a79147b3.png";